export default __webpack_public_path__ + "locales/uk-UA/PrivacyPage.json?hash=2e7d04e3457c82f83f75aff5f456cbdb";